<style src="../css/head.css"></style>

<style src="../css/detail.css"></style>
<template>
  <div>
    <Head-section></Head-section>
    <div class="container">
      <b-card>
        <dt>{{title}}</dt>
        <div>{{$t('message.Author')}}: {{createby}}</div>
        <div>{{$t('message.Published_on')}} {{createat|time}}</div>
      </b-card>
      <div v-html="context"></div>
    </div>
    <Foot-section></Foot-section>
  </div>
</template>

<script>
  import {
    mapActions,
    mapGetters
  } from "vuex";
  // import HeadSection from "./HeadCommSection.vue";
  import HeadSection from "./HeadSection.vue";
  import FootSection from "./FootSection.vue";
  export default {
    name: "Article",
    components: {
      HeadSection,
      FootSection
    },
    data() {
      return {
        context: "",
        createby: "",
        createat: "",
        title: ""
      };
    },
    computed: {
      ...mapGetters(["lan", "lan_array"])
    },
    watch: {
      lan(oldlan, newlan) {

        this.getArtByid(this.$route.params.articleid, 0, 20);
      }
    },
    created() {
      let language = this.$route.params.language;
      if(this.$store.state.lan_array.indexOf(language) == -1){
        this.toHome();
      }
      const aid = this.$route.params.articleid;
      this.getArtByid(aid, 0, 20);
    },
    methods: {
      ...mapActions({
      getArtByid(dispatch, aid, pg, pgs) {
        dispatch("getArtByid", {
          aid,
          pg,
          pgs
        }).then(data => {
          if (data.result) {
            this.context = data.topic.context.replace(
              /<img/g,
              '<img class="img-fluid"'
            );
            this.title = data.topic.title;
            this.createby = data.topic.createby;
            this.createat = data.topic.createat;
          }
        });
      }
    }),
    toHome() {
      let nameHome = this.lan + "home";
      this.$router.replace({
        name: nameHome
      });
    },
    }
  };
</script>